import {PageLayout} from "base/layout";
import {SistemaExplotacionService} from "medioreceptor/service";
import {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {SistemaExplotacionPageMenu} from "../menu";
import {AlertError, SpinnerFullHeight} from "base/component/presentational";
import {useAppConfig} from "base/provider";

const ViewSistemaExplotacionPage = () => {
    const {setPagePath} = useAppConfig();

    const {id} = useParams();
    const [sistemaExplotacion, setSistemaExplotacion] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setLoading(true);
        SistemaExplotacionService.get(id)
            .then(data => {
                setPagePath([
                    {
                        name: `Sistema de explotación: ${data.nome}`,
                        path: `sistemaexplotacion/${data.id}`,
                    },
                ]);
                setSistemaExplotacion(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
        return () => {
            setPagePath([]);
            setSistemaExplotacion(null);
        };
    }, [id, location.state?.lastRefreshDate]);

    return loading ? (
        <SpinnerFullHeight />
    ) : error ? (
        <AlertError error={error} />
    ) : (
        sistemaExplotacion && (
            <PageLayout
                menu={
                    <SistemaExplotacionPageMenu
                        sistemaExplotacion={sistemaExplotacion}
                    />
                }
                context={[sistemaExplotacion]}
            />
        )
    );
};
export default ViewSistemaExplotacionPage;
